import * as React from "react";

interface ICircularProgressbarSvgProps {
  currentStep: number;
  totalSteps: number;
}

export const CircularProgressbarSvg = (props: ICircularProgressbarSvgProps) => {
  const radius = 27;
  const strokeDasharray = 2 * Math.PI * radius;

  return (
    <div className="circular-progressbar-module">
      <svg
        viewBox="0 0 60 60"
        width={60}
        height={60}
        xmlns="http://www.w3.org/2000/svg"
        className="circular-progressbar-svg"
      >
        <circle
          r={radius}
          cx="30"
          cy="30"
          className="progressbar-background"
          fill="transparent"
          strokeDasharray={strokeDasharray}
          strokeDashoffset="0"
        ></circle>

        <circle
          className="progressbar-bar"
          r={radius}
          cx="30"
          cy="30"
          fill="transparent"
          strokeDasharray={strokeDasharray}
          strokeDashoffset={parseInt(
            (((props.totalSteps - props.currentStep) * strokeDasharray) / props.totalSteps).toString()
          ).toString()}
        ></circle>
      </svg>
      <span className="circular-progressbar-text"> {`${props.currentStep} / ${props.totalSteps}`} </span>
    </div>
  );
};
